import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { CreatedSitesList } from "./pages";

export const CreatedSitesRouter = [
  <Route
    path="/created-sites"
    element={
      <ProtectedRoute roles={["Any"]}>
        <CreatedSitesList />
      </ProtectedRoute>
    }
  />,
];
